var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57129 0.142578C2.80987 0.142578 0.571289 2.38115 0.571289 5.14258V11.1745C0.571289 13.1346 1.98118 14.7655 3.84218 15.1082C4.30606 16.6967 5.77342 17.8572 7.51182 17.8572H12.0383C14.2474 17.8572 16.0383 16.0663 16.0383 13.8572V7.20859C16.0383 5.44124 14.8921 3.94159 13.3025 3.41247C13.2588 1.59915 11.7752 0.142578 9.9514 0.142578H5.57129ZM11.2731 3.20859C11.1419 2.59925 10.6 2.14258 9.9514 2.14258H5.57129C3.91444 2.14258 2.57129 3.48572 2.57129 5.14258V11.1745C2.57129 11.9625 3.02707 12.6441 3.6894 12.9701V7.03101C3.6894 4.91994 5.40076 3.20859 7.51182 3.20859H11.2731ZM12.0383 15.8572H7.51182C6.50533 15.8572 5.6894 15.0413 5.6894 14.0348V7.03101C5.6894 6.02451 6.50533 5.20859 7.51182 5.20859H12.0383C13.1428 5.20859 14.0383 6.10402 14.0383 7.20859V13.8572C14.0383 14.9618 13.1428 15.8572 12.0383 15.8572Z",
    fill: "#151C22"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.63b1e6c0.svg";
export { ForwardRef as ReactComponent };